<template>
    <div id="navigation-outer">
        <div id="navigation-inner">
            <slot
                :is-visible="isVisible"
                :toggle="toggle"
                :expandedClass="expandedClass"
            ></slot>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                expanded: null,
                visible: false,
                breakpoints: ['medium', 'large'],
                media: window.ViewPort.media
            }
        },
        computed: {
            isVisible() {
                if (this.breakpoints.includes(this.media)) {
                    return true;
                }

                return this.visible;
            }
        },
        created() {
            window.EventHandler.listen('toggle-navigation', this.navigationToggled);
            window.EventHandler.listen('window-resized', this.windowResized);
            window.EventHandler.listen('body-clicked', event => {
                if (!this.$el.contains(event.target) && this.breakpoints.includes(window.ViewPort.media)) {
                    this.hide();
                }
            });
        },
        methods: {
            navigationToggled() {
                this.reset();
                this.visible = !this.visible;
                window.EventHandler.fire('navigation-toggled', this.visible);
            },
            windowResized(viewPort) {
                if (viewPort.media !== this.media) {
                    this.media = viewPort.media;
                    if (!this.breakpoints.includes(this.media)) {
                        this.hide();
                    }
                }
            },
            hide() {
                this.reset();
                this.visible = false;
                window.EventHandler.fire('navigation-toggled', this.visible);
            },
            reset() {
                this.expanded = null;
            },
            toggle(index) {
                if (this.isExpanded(index)) {
                    this.reset();
                } else {
                    this.expanded = index;
                }
            },
            isExpanded(index) {
                return this.expanded === index;
            },
            expandedClass(index) {
                return {
                    expanded: this.isExpanded(index)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Navigation/Wrapper.vue